import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faChartLine } from '@fortawesome/free-solid-svg-icons';
import { useContainerStats } from '../hooks/useContainerStats';

/**
 * ContainerStats Component
 * Displays real-time resource usage statistics
 */
export function ContainerStats({ containerId }) {
  const { stats, loading } = useContainerStats(containerId, true, 3000);

  if (loading && !stats) {
    return (
      <div className="flex items-center justify-center h-64">
        <FontAwesomeIcon icon={faSpinner} spin size="2x" className="text-theme-button-color" />
      </div>
    );
  }

  if (!stats) {
    return (
      <div className="flex flex-col items-center justify-center h-64 text-theme-hint-color">
        <FontAwesomeIcon icon={faChartLine} size="2x" className="opacity-40 mb-4" />
        <p>Статистика недоступна</p>
      </div>
    );
  }

  return (
    <div className="p-3 sm:p-4 space-y-3 sm:space-y-4 h-full overflow-y-auto">
      {/* CPU */}
      <div className="bg-theme-secondary-bg-color rounded-lg p-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-theme-text-color font-medium">CPU</span>
          <span className="text-theme-link-color font-bold">{stats.cpuPercent}</span>
        </div>
        <div className="w-full bg-theme-bg-color rounded-full h-2">
          <div
            className="bg-blue-500 h-2 rounded-full transition-all duration-300"
            style={{ width: stats.cpuPercent }}
          ></div>
        </div>
      </div>

      {/* Memory */}
      <div className="bg-theme-secondary-bg-color rounded-lg p-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-theme-text-color font-medium">Memory</span>
          <span className="text-theme-link-color font-bold">{stats.memoryPercent}</span>
        </div>
        <div className="text-xs text-theme-hint-color mb-2">
          {stats.memoryUsage} / {stats.memoryLimit}
        </div>
        <div className="w-full bg-theme-bg-color rounded-full h-2">
          <div
            className="bg-green-500 h-2 rounded-full transition-all duration-300"
            style={{ width: stats.memoryPercent }}
          ></div>
        </div>
      </div>

      {/* Network I/O */}
      <div className="bg-theme-secondary-bg-color rounded-lg p-4">
        <span className="text-theme-text-color font-medium block mb-3">Network I/O</span>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <div className="text-xs text-theme-hint-color mb-1">Input</div>
            <div className="text-theme-link-color font-bold">{stats.networkInput}</div>
          </div>
          <div>
            <div className="text-xs text-theme-hint-color mb-1">Output</div>
            <div className="text-theme-link-color font-bold">{stats.networkOutput}</div>
          </div>
        </div>
      </div>

      {/* Block I/O */}
      <div className="bg-theme-secondary-bg-color rounded-lg p-4">
        <span className="text-theme-text-color font-medium block mb-3">Block I/O</span>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <div className="text-xs text-theme-hint-color mb-1">Read</div>
            <div className="text-theme-link-color font-bold">{stats.blockInput}</div>
          </div>
          <div>
            <div className="text-xs text-theme-hint-color mb-1">Write</div>
            <div className="text-theme-link-color font-bold">{stats.blockOutput}</div>
          </div>
        </div>
      </div>

      {/* PIDs */}
      <div className="bg-theme-secondary-bg-color rounded-lg p-4">
        <div className="flex items-center justify-between">
          <span className="text-theme-text-color font-medium">PIDs</span>
          <span className="text-theme-link-color font-bold">{stats.pids}</span>
        </div>
      </div>
    </div>
  );
}

export default ContainerStats;
